module.exports = __webpack_public_path__ + "static/PPNeueMontreal-Regular-c9d07127480b3e924fecf0feb32fefe5.woff";